import type { ElementMapping } from 'ts/types'
import useApp from './useApp'

const FALLBACK: ElementMapping = {
  element1: 'E1',
  element2: 'E2',
  element3: 'E3',
  element4: 'E4'
}

/**
 * Tenant hierarchy labels from AppProvider (`sorElementMapping`).
 * Use for table headers and tooltips — never hardcode Business / Department / Portfolio / Product.
 */
export function useElementLabels(): ElementMapping {
  const { sorElementMapping } = useApp()

  return {
    element1: sorElementMapping?.element1?.trim() || FALLBACK.element1,
    element2: sorElementMapping?.element2?.trim() || FALLBACK.element2,
    element3: sorElementMapping?.element3?.trim() || FALLBACK.element3,
    element4: sorElementMapping?.element4?.trim() || FALLBACK.element4
  }
}
